// extracted by mini-css-extract-plugin
export default {"startContainer":"start_startContainer__ARCSZ","startDiv":"start_startDiv__QKdX5"};